<template>
  <div class="drone-sensor-data-view" @click.stop>
    <MCard class="content" :title="'传感器列表'">
      <scrollView :monitorList="monitorList" @showChart="toggleSensor" />
    </MCard>
  </div>
</template>
<script>
import MCard from '@/components/mCard/index';
import HeaderIcon from '@/assets/image/components/fire.png';
import scrollView from '../real-data/components/scroll-view.vue';

export default {
  props: {
    seneorData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    MCard,
    scrollView
  },
  watch: {
    seneorData: {
      handler(newVal) {
        this.monitorList = [...newVal];
      },
      deep: true
    }
  },
  data() {
    return {
      monitorList: [],
      arrowLeft: '306px',
      icon: {
        type: 'image',
        config: {
          src: HeaderIcon
        }
      }
    };
  },

  methods: {
    toggleSensor(val, index) {
      this.$emit('toggleSensor', val.name, index);
    }
  }
};
</script>

<style scoped lang="scss">
.drone-sensor-data-view {
  position: relative;
  background: linear-gradient(90deg, rgba(32, 62, 88, 0.3) 0%, rgba(32, 62, 88, 0.7) 100%);
}
</style>
